// iter141 — Global refresh event bus
// POST/PUT/DELETE sonrası tüm subscribing sayfalar otomatik yeniden yükler.
// Sayfaya özel refresh anahtarları resource path'e göre:
//   /orders* → "orders", /tasks* → "tasks", /scheduled-cashflows* → "cashflow"
// Sayfa tüm mutasyonları dinlemek isterse "*" verir.

const listeners = new Map(); // key: string, value: Set<callback>

export function subscribe(key, cb) {
  if (!listeners.has(key)) listeners.set(key, new Set());
  listeners.get(key).add(cb);
  return () => listeners.get(key)?.delete(cb);
}

export function emit(key) {
  // Belirtilen key + "*" wildcard dinleyicileri tetikle
  listeners.get(key)?.forEach((cb) => { try { cb(); } catch {} });
  listeners.get("*")?.forEach((cb) => { try { cb(key); } catch {} });
}

// URL path → resource key
const PATH_TO_KEY = [
  { rx: /\/scheduled-cashflows/, key: "cashflow" },
  { rx: /\/finance\//, key: "cashflow" },
  { rx: /\/cheques/, key: "cashflow" },
  { rx: /\/notes/, key: "cashflow" },
  { rx: /\/payments/, key: "cashflow" },
  { rx: /\/tasks/, key: "tasks" },
  { rx: /\/orders/, key: "orders" },
  { rx: /\/quotes/, key: "quotes" },
  { rx: /\/customers/, key: "customers" },
  { rx: /\/suppliers/, key: "suppliers" },
  { rx: /\/products|\/stock|\/variants/, key: "products" },
  { rx: /\/notifications/, key: "notifications" },
  { rx: /\/purchases|\/purchase-orders/, key: "purchases" },
  { rx: /\/expenses/, key: "expenses" },
  { rx: /\/employees|\/positions|\/payrolls/, key: "hr" },
  { rx: /\/vehicles|\/shipments/, key: "logistics" },
  { rx: /\/dashboard/, key: "dashboard" },
];

export function keyFromPath(path = "") {
  for (const p of PATH_TO_KEY) {
    if (p.rx.test(path)) return p.key;
  }
  return null;
}
